<template>
  <div
    style="background-color: #fafafa;
  width: 100%;
  height: 100%;
  padding: 15px;"
  >
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({})
</script>
